import React, { useEffect } from "react";
import InnerHero from "../components/InnerHero";
import MapSection from "../components/MapSection";
import { Container, Row, Col } from "react-bootstrap";
import {
    FaPhoneAlt,
    FaEnvelope,
    FaMapMarkerAlt
} from "react-icons/fa";

function Contact() {
    // scroll animation (one time for home page)
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("show");
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);
    return (
        <>
            <InnerHero
                title="Contact Hindustan Agro Life"
                subtitle="Get in touch with us for product inquiries, distributor partnerships, and reliable agricultural solutions designed for Indian farming."
                bgImage="/images/img/contact-hero.jpg"
            />
            <section className="section contact-info-section">
                <Container>

                    {/* Section Heading */}
                    <div className="section-title fade-up">
                        <h2>Get in Touch</h2>
                        <p>
                            Have questions or need assistance? Our team is here to guide you with
                            the right agricultural solutions and support.
                        </p>
                    </div>

                    <Row>
                        {/* PHONE */}
                        <Col lg={4} md={6} className="mb-4 fade-up">
                            <a href="tel:+919243215585" className="contact-card link-card">
                                <FaPhoneAlt />
                                <h5>Call Us</h5>
                                <p>+91 9243215585</p>
                            </a>
                        </Col>

                        {/* EMAIL */}
                        <Col lg={4} md={6} className="mb-4 fade-up">
                            <a
                                href="mailto:hindustanagrolife@gmail.com"
                                className="contact-card link-card"
                            >
                                <FaEnvelope />
                                <h5>Email Us</h5>
                                <p>hindustanagrolife@gmail.com</p>
                            </a>
                        </Col>

                        {/* LOCATION */}
                        <Col lg={4} md={6} className="mb-4 fade-up">
                            <a
                                href="https://maps.app.goo.gl/wUWw86a1dye9YdjN8"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="contact-card link-card"
                            >
                                <FaMapMarkerAlt />
                                <h5>Office Location</h5>
                                <p>
                                    Ratlam, Madhya Pradesh <br /> 457001, India
                                </p>
                            </a>
                        </Col>
                    </Row>

                    <div className="contact-support fade-up">
                        <p>
                            Need guidance or product information? Reach out to our support team —
                            share your enquiry and we’ll get back to you at the earliest.
                        </p>
                    </div>

                </Container>
            </section>

            {/* Next: Contact Info + Form section yahan aayega */}

            <MapSection />
        </>
    );
};

export default Contact;
